import React, { createContext } from 'react';
import { getSummitTier, tierTypeIds } from '../../summit-program/summit';

import { getLoginStatus } from '../../nitro-client/authentication';
import { updateAnalyticsUserSummitTier } from '../../utils/analytics-util';

export const UserContext = createContext();

export default class WithUserState extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loggedIn: false,
            userStateLoaded: false,
            summitTier: tierTypeIds.NONE,
            summitTierLoaded: false
        };
    }

    componentDidMount() {
        this.initUserState();
    }

    // this will cause a layout thrash... how do we avoid this...
    async initUserState() {
        const loggedIn = await getLoginStatus();
        const summitTier = loggedIn ? await getSummitTier() : tierTypeIds.NONE;
        this.setState({
            loggedIn,
            summitTier,
            summitTierLoaded: true,
            userStateLoaded: true
        });

        updateAnalyticsUserSummitTier(summitTier.toString());
    }

    render() {
        const { children, ...rest } = this.props;
        if (typeof children === 'function') {
            return children({ ...rest, ...this.state });
        }
        return false;
    }
}
